var render = function () {
  var _vm$cities;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "pt-4 overflow-y-auto relative body pb-24"
  }, [_c('div', {
    staticClass: "px-6 flex-grow"
  }, [_c('div', {
    staticClass: "space-y-5"
  }, [_c('TextField', {
    attrs: {
      "label": "Nama Perusahaan",
      "required": true
    },
    model: {
      value: _vm.form.name,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "name", $$v);
      },
      expression: "form.name"
    }
  }), _c('TextField', {
    attrs: {
      "label": "Nama Admin Pengirim",
      "required": true
    },
    model: {
      value: _vm.form.sender_name,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "sender_name", $$v);
      },
      expression: "form.sender_name"
    }
  }), _c('TextField', {
    attrs: {
      "label": "Email",
      "required": true,
      "disabled": ""
    },
    model: {
      value: _vm.form.email,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "email", $$v);
      },
      expression: "form.email"
    }
  }), _c('div', [_c('label', {
    staticClass: "text-sm text-neutral-700 font-medium mb-1 inline-block"
  }, [_vm._v(" Alamat Pengirim ")]), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.pickup_address,
      expression: "form.pickup_address"
    }],
    staticClass: "w-full border border-neutral-300 rounded-md p-2 text-sm focus:outline-none focus:border-primary-700",
    attrs: {
      "rows": "3",
      "placeholder": "Masukkan alamat lengkap penjemputan"
    },
    domProps: {
      "value": _vm.form.pickup_address
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }

        _vm.$set(_vm.form, "pickup_address", $event.target.value);
      }
    }
  })]), _c('TextField', {
    attrs: {
      "label": "Petunjuk Pengiriman",
      "placeholder": "Masukan petunjuk sebagai patokan"
    },
    model: {
      value: _vm.form.detail_address,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "detail_address", $$v);
      },
      expression: "form.detail_address"
    }
  }), _c('div', {
    staticClass: "relative"
  }, [_c('label', {
    staticClass: "text-sm text-neutral-700 font-medium mb-1 inline-block"
  }, [_vm._v(" Kecamatan / Kelurahan / Kodepos ")]), _c('TextField', {
    attrs: {
      "type": "text",
      "placeholder": "Cari kecamatan / kodepos"
    },
    on: {
      "input": _vm.searchArea
    },
    model: {
      value: _vm.areaSearch,
      callback: function callback($$v) {
        _vm.areaSearch = $$v;
      },
      expression: "areaSearch"
    }
  }), _c('div', {
    staticClass: "absolute right-3 top-1/2 -translate-y-1/2 flex items-center justify-center text-neutral-400 pointer-events-none"
  }, [_vm.isSearching ? _c('div', {
    staticClass: "animate-spin h-4 w-4 border-2 border-primary-700 border-t-transparent rounded-full"
  }) : _c('Search', {
    staticClass: "w-5 h-5"
  })], 1), _vm.showAreaSuggestion ? _c('div', {
    staticClass: "absolute z-20 mt-1 w-full bg-white border rounded-md max-h-48 overflow-y-auto"
  }, [(_vm$cities = _vm.cities) !== null && _vm$cities !== void 0 && _vm$cities.length ? _c('ul', _vm._l(_vm.cities, function (item, index) {
    return _c('li', {
      key: index,
      staticClass: "px-3 py-2 cursor-pointer hover:bg-neutral-100 text-sm",
      on: {
        "click": function click($event) {
          return _vm.selectArea(item);
        }
      }
    }, [_vm._v(_vm._s(item.village) + ", " + _vm._s(item.area_display))]);
  }), 0) : _c('div', {
    staticClass: "p-3 text-sm text-neutral-500"
  }, [_vm._v(" Data tidak ditemukan ")])]) : _vm._e()], 1), _c('div', {
    staticClass: "grid grid-cols-2 gap-4"
  }, [_c('TextField', {
    attrs: {
      "label": "Latitude",
      "placeholder": "-6.xxxx"
    },
    model: {
      value: _vm.form.lat,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "lat", $$v);
      },
      expression: "form.lat"
    }
  }), _c('TextField', {
    attrs: {
      "label": "Longitude",
      "placeholder": "107.xxxx"
    },
    model: {
      value: _vm.form.lng,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "lng", $$v);
      },
      expression: "form.lng"
    }
  })], 1), _c('TextField', {
    attrs: {
      "label": "No. Handphone",
      "required": true
    },
    model: {
      value: _vm.form.phone_number,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "phone_number", $$v);
      },
      expression: "form.phone_number"
    }
  }), _c('div', [_c('label', {
    staticClass: "text-sm text-neutral-700 font-medium mb-1 inline-block"
  }, [_vm._v(" Volume Transaksi ")]), _c('CustomSelect', {
    attrs: {
      "options": _vm.volumeList,
      "optionLabel": "label",
      "optionValue": "value",
      "placeholder": "Pilih estimasi volume"
    },
    model: {
      value: _vm.selectedVolume,
      callback: function callback($$v) {
        _vm.selectedVolume = $$v;
      },
      expression: "selectedVolume"
    }
  })], 1), _c('TextField', {
    attrs: {
      "label": "Bidang Usaha",
      "placeholder": "Contoh: Retail, Manufaktur"
    },
    model: {
      value: _vm.form.business_field,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "business_field", $$v);
      },
      expression: "form.business_field"
    }
  }), _c('div', [_c('label', {
    staticClass: "text-sm text-neutral-700 font-bold mb-3 block border-b pb-2"
  }, [_vm._v(" Kategori Barang ")]), _c('div', {
    staticClass: "grid grid-cols-2 gap-y-2"
  }, _vm._l(_vm.goodsCategories, function (item) {
    return _c('label', {
      key: item.code,
      staticClass: "flex items-center gap-2 text-sm cursor-pointer"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: _vm.form.categories,
        expression: "form.categories"
      }],
      staticClass: "w-4 h-4 accent-primary-700",
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": item.name,
        "checked": Array.isArray(_vm.form.categories) ? _vm._i(_vm.form.categories, item.name) > -1 : _vm.form.categories
      },
      on: {
        "change": function change($event) {
          var $$a = _vm.form.categories,
              $$el = $event.target,
              $$c = $$el.checked ? true : false;

          if (Array.isArray($$a)) {
            var $$v = item.name,
                $$i = _vm._i($$a, $$v);

            if ($$el.checked) {
              $$i < 0 && _vm.$set(_vm.form, "categories", $$a.concat([$$v]));
            } else {
              $$i > -1 && _vm.$set(_vm.form, "categories", $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
            }
          } else {
            _vm.$set(_vm.form, "categories", $$c);
          }
        }
      }
    }), _c('span', [_vm._v(_vm._s(item.name))])]);
  }), 0)])], 1)]), _c('div', {
    staticClass: "px-6 pb-6 bg-white fixed bottom-0 left-0 z-10 w-full border-t pt-4"
  }, [_c('Button', {
    attrs: {
      "buttonText": "Update Profil Mitra",
      "size": "full"
    },
    on: {
      "action": _vm.submitForm
    }
  })], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }